export const defaultBim4DPricingRules = {
  surfaceSettings: {
    minimumSurface: 1000,
    jhPerSquareMeter: 0.003,
  },
  taskSettings: {
    minimumTasks: 20,
    jhPerTask: 0.3,
  },
  deliverables: {
    defaultPackageFactor: 1,
    videoExportFactor: 1.2,
    navisworksSynchroFactor: 1.8,
  },
  siteFollowUp: {
    minimumWeeks: 4,
    weeklyLight: 2,
    weeklyStandard: 4,
    weeklyIntensive: 6,
    sizeFactorThreshold: 40,
    sizeFactorMin: 1,
    sizeFactorMax: 2,
  },
  rateTiers: [
    { min: 500, rate: 120 },
    { min: 300, rate: 140 },
    { min: 150, rate: 160 },
    { min: 100, rate: 180 },
    { min: 50, rate: 200 },
    { min: 40, rate: 210 },
    { min: 30, rate: 220 },
    { min: 20, rate: 230 },
    { min: 10, rate: 240 },
    { min: 5, rate: 250 },
    { min: 1, rate: 280 },
    { min: 0, rate: 280 },
  ],
};

export const cloneBim4DPricingRules = () => JSON.parse(JSON.stringify(defaultBim4DPricingRules));